import React from 'react';
import { FileText } from 'lucide-react';

export function CampaignImagePlaceholder() {
  return (
    <div className="w-full md:w-32 h-32 rounded-lg bg-gradient-to-br from-orange-100 to-orange-200 flex items-center justify-center flex-shrink-0">
      <FileText className="w-12 h-12 text-orange-600" strokeWidth={1.5} />
    </div>
  );
}
